import shallow from 'zustand/shallow';
import useStore from '..';
import { ActivitiesSlice } from '../activities';

export interface UseActivitiesHook {
  all: ActivitiesSlice['all'];
  suggestions: ActivitiesSlice['suggestions'];
  currentSuggestion: ActivitiesSlice['currentSuggestion'];
  currentSearch: ActivitiesSlice['currentSearch'];
  currentPeriod: ActivitiesSlice['currentPeriod'];
  actions: {
    find: ActivitiesSlice['find'];
    findSuggestions: ActivitiesSlice['findSuggestions'];
    setCurrentSuggestion: ActivitiesSlice['setCurrentSuggestion'];
    setCurrentSearch: ActivitiesSlice['setCurrentSearch'];
    setCurrentPeriod: ActivitiesSlice['setCurrentPeriod'];
  };
}

export const useActivities = (): UseActivitiesHook => {
  const [
    find,
    findSuggestions,
    all,
    suggestions,
    currentSuggestion,
    setCurrentSuggestion,
    currentSearch,
    setCurrentSearch,
    currentPeriod,
    setCurrentPeriod,
  ] = useStore(
    (state) => [
      state.activities.find,
      state.activities.findSuggestions,
      state.activities.all,
      state.activities.suggestions,
      state.activities.currentSuggestion,
      state.activities.setCurrentSuggestion,
      state.activities.currentSearch,
      state.activities.setCurrentSearch,
      state.activities.currentPeriod,
      state.activities.setCurrentPeriod,
    ],
    shallow,
  );

  return {
    all,
    suggestions,
    currentSuggestion,
    currentSearch,
    currentPeriod,
    actions: {
      findSuggestions,
      setCurrentSuggestion,
      find,
      setCurrentSearch,
      setCurrentPeriod,
    },
  };
};
